import { Zap } from 'lucide-react';
import './Footer.css';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footerInner">
        <div className="footerLogo">
          <Zap size={20} />
          Keraunos
        </div>

        <div className="footerCopy">© {year} Keraunos AI. Architected by Gregory Kennedy.</div>

        <nav className="footerLinks">
          <a href="#">Privacy</a>
          <a href="#">Terms</a>
          <a href="mailto:office@keraunos-ai.com">Contact</a>
        </nav>
      </div>
    </footer>
  );
}
